<template>
  <div ref="observerSection">
    <slot />
  </div>
</template>

<script lang="ts">

import { useIntersectionObserver } from '@vueuse/core';

import type { AnchorNavOptions } from '~~/types/product/AnchorNav';

export default defineComponent({
  name: 'AnchorNavigationSectionWrapper',
  setup (_props) {

    const observerSection = ref(null);
    const { activeSection, setActiveSection, observerRootMargin } = useAnchorNavigationStore();

    const updateActiveSection = ({ isIntersecting, target }: IntersectionObserverEntry) => {

      const id = target.getAttribute('id') as AnchorNavOptions;

      if (isIntersecting) {

        setActiveSection(id);

      } else if (activeSection.value === id) {

        setActiveSection(null);

      }

    };

    useIntersectionObserver(observerSection, ([entry]) => updateActiveSection(entry), {
      threshold: 0,
      rootMargin: observerRootMargin.value,
    });

    return {
      observerSection,
    };
  
  },
});

</script>
